function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import isObjectLike from 'lodash/isObjectLike';
import styles from './Chip.pcss';
var _React_PureComponent;
class Chip extends (_React_PureComponent = React.PureComponent) {
    renderLabel() {
        const { labelMessage } = this.props;
        if (!labelMessage) {
            return null;
        }
        if (isObjectLike(labelMessage) && !/*#__PURE__*/ React.isValidElement(labelMessage)) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, labelMessage));
        }
        return labelMessage;
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: cn(styles.chip, {
                [styles[`chip--${this.props.styleModifier}`]]: this.props.styleModifier
            }, this.props.className),
            children: this.renderLabel()
        });
    }
}
_define_property(Chip, "propTypes", {
    // Explicit props
    labelMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element
    ]).isRequired,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    styleModifier: PropTypes.oneOf([
        'inactive',
        'error',
        'success',
        'pending'
    ])
});
_define_property(Chip, "defaultProps", {
    className: ''
});
export default withStyles(styles)(Chip);
